import { env } from './env'
console.log("env", env)
console.log("DEBUG: data below...");
console.log("REACT_APP_MICROSOFT_ENTRA_CLIENT_ID", `${env.REACT_APP_MICROSOFT_ENTRA_CLIENT_ID}`);
export const msalConfig = {
    auth: {
        clientId: env.REACT_APP_MICROSOFT_ENTRA_CLIENT_ID,
        authority: env.REACT_APP_MICROSOFT_ENTRA_DOMAIN,
        redirectUri: env.REACT_APP_REDIRECT_URI,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};
